export default {
      id: "upload-cloud-usage",
      viewBox: "0 0 22 21",
      url: __webpack_public_path__ + "sprite.svg#upload-cloud",
      toString: function () {
        return this.url;
      }
    }